
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { DialogConfirmComponent } from '../dialog/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { AppService, GRSSUserRoles } from '../_services/app.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard  {

  constructor(private dialog: MatDialog, private service: AppService) {}

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    

    // if there are no pending changes, just allow deactivation; else confirm first
    return (component && component.canDeactivate()) || !component ?
      true :
      // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
      // when navigating away from your angular app, the browser will show a generic warning message
      // see http://stackoverflow.com/a/42207299/7307355
      from(this.checkResponse()); // convert promise to observable
  }

  /** Check the user's authentication status */
  checkResponse(): Promise<boolean> {

    // tslint:disable-next-line: no-shadowed-variable
    return new Promise((resolve, reject) => {
      this.dialog.open(DialogConfirmComponent, {
        disableClose: true,
        data: {
          title: 'WARNING: Unsaved Changes',
          message: 'Do you need to leave the page despite these changes?',
          innerHTML: true
        },
        position: { top: '5%' }
      }).afterClosed().subscribe((res: boolean) => {
        resolve(res);
      });
    });
  }
}
